import { app } from '../../../../app';

app.factory('HardTokenSamlLoginService', HardTokenSamlLoginService);
/** @ngInject */
function HardTokenSamlLoginService($resource) {
    // hardtoken/u2floginstart POST
    return $resource('app/rest/hardtoken/u2fsamlloginstart/:appKey', {
        appKey: '@appKey'
    }, {});


}


// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/hard-token-login/hard-token-saml-login.service.js